













import { Component, Vue } from 'vue-property-decorator'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


interface RequestPayload {
    pulsemAccountId: number|null;
    fromDate: string|null;
    toDate: string|number|null;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard
    }
})
export default class SocialReviewsReport extends Vue {
    locationValid = false
    pulsemAccountId: number|null = null
    fromDate: string|null = null
    toDate: string|null = null

    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId,
            fromDate: this.fromDate,
            toDate: this.toDate
        }
    }

    async onLocationChange(locationValid: boolean) {
        this.locationValid = locationValid
        if (!this.locationValid) {
            this.fromDate = null
            this.toDate = null
        }
    }

    onSuccess(status: boolean) {
        if (status) {
            this.pulsemAccountId = null
            this.fromDate = null
            this.toDate = null
        }
    }
}
